var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpyroHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29395",
    "data-name": "Group 29395",
    transform: "translate(-422 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(422 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-spyro_1_",
    "data-name": "icons8-spyro (1)",
    transform: "translate(439 349.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50122",
    "data-name": "Path 50122",
    d: "M22.882,10.9a7.191,7.191,0,0,1,2.909-.416,5.178,5.178,0,0,0-4.376-3.459l-.407-.049L22.05,3.831c-4.155,0-5.4,1.662-5.4,1.662.1-.814.527-2.292,1.247-2.493-4.155,0-4.571,2.909-4.571,2.909A3.472,3.472,0,0,1,12.078,3,3.9,3.9,0,0,0,10,6.74a5.042,5.042,0,0,0,.416,2.078l9.142,12.051h2.909a3.179,3.179,0,0,0-.831-2.078,5.268,5.268,0,0,1,2.493.831,8.06,8.06,0,0,0-1.247-4.571,5.749,5.749,0,0,1,2.909.831A6.118,6.118,0,0,0,22.882,10.9Z",
    transform: "translate(-5.845 -1.753)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50123",
    "data-name": "Path 50123",
    d: "M17.206,18.649a8.892,8.892,0,0,1-2.078,4.986v2.443l-6.649.05V24.466s-4.143,0-5.959-.831c0,0,0,0-.008,0L2.247,22.8H1.831A4.162,4.162,0,0,1,1,20.311V19.9c0-.416.3-.416.416-.416H3.909V16.155s-.777-.374-.831-.831a4.957,4.957,0,0,1,.935-1.247C5.937,12.366,8.064,12,10.557,12A6.555,6.555,0,0,1,17.206,18.649Z",
    transform: "translate(-0.584 -7.013)",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50124",
    "data-name": "Path 50124",
    d: "M.416,30.247a2.749,2.749,0,0,0,.416-.831A.416.416,0,0,0,.416,29,.443.443,0,0,0,0,29.467.963.963,0,0,0,.416,30.247Z",
    transform: "translate(0 -16.949)",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50125",
    "data-name": "Path 50125",
    d: "M10.493,23.155V19l-1.662.416L8,20.662s.831.072.831.831v1.662Z",
    transform: "translate(-4.676 -11.104)",
    fill: "#512da8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50126",
    "data-name": "Path 50126",
    d: "M14.3,25.409H12V22.5c0-2.493,2.909-2.493,2.909.831C14.909,24.994,14.3,25.409,14.3,25.409Z",
    transform: "translate(-7.014 -12.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50127",
    "data-name": "Path 50127",
    d: "M12.781,25.493c.486,0,.881-.558.881-1.247S13.267,23,12.781,23a.771.771,0,0,0-.76.738c-.012.155-.021.324-.021.509s.008.349.017.5A.769.769,0,0,0,12.781,25.493Z",
    transform: "translate(-7.014 -13.442)",
    fill: "#ab47bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50128",
    "data-name": "Path 50128",
    d: "M12.831,24.831c0,.46-.208.831-.465.831-.141,0-.366-.138-.366-.831s.229-.831.366-.831C12.623,24,12.831,24.371,12.831,24.831Z",
    transform: "translate(-7.014 -14.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50129",
    "data-name": "Path 50129",
    d: "M14.416,23a.416.416,0,1,0,.416.416A.416.416,0,0,0,14.416,23Z",
    transform: "translate(-8.183 -13.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50130",
    "data-name": "Path 50130",
    d: "M32.623,24c-.344,0-.623.372-.623.831s.279.831.623.831.623-.372.623-.831S32.968,24,32.623,24Zm1.454,1.247c-.416,0-.416.364-.416.519,0,.208.312.727.416.727s.416-.467.416-.727C34.493,25.61,34.493,25.247,34.078,25.247Zm-1.247,1.247c-.416,0-.416.364-.416.519,0,.208.312.727.416.727s.416-.467.416-.727C33.247,26.857,33.247,26.493,32.831,26.493Z",
    transform: "translate(-18.703 -14.027)",
    fill: "#512da8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50131",
    "data-name": "Path 50131",
    d: "M10.726,28C9.064,28,8.649,29.247,7.4,29.247c-1.039,0-1.247-.675-1.247-.831H5.324L4.493,28A5.268,5.268,0,0,1,2,28.831a7.28,7.28,0,0,0,4.986,1.662,3.64,3.64,0,0,0,2.493-.831,1.961,1.961,0,0,0,1.247.416c.918,0,1.662-.465,1.662-1.039S11.644,28,10.726,28Z",
    transform: "translate(-1.169 -16.364)",
    fill: "#764ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50132",
    "data-name": "Path 50132",
    d: "M11.48,35.416v.831a3.156,3.156,0,0,1-1.35-.278,11.891,11.891,0,0,1-5.714,1.109H4.274s0,0-.008,0L4,36.247h.416a10.615,10.615,0,0,0,5.5-1.114L10.142,35l.216.145A2.131,2.131,0,0,0,11.48,35.416Zm3.74.831S14.8,37.909,11.9,37.909v.831C12.311,38.74,15.219,38.74,15.219,36.247Z",
    transform: "translate(-2.338 -20.456)",
    fill: "#4a148c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28944",
    "data-name": "Group 28944",
    transform: "translate(7.895 17.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50133",
    "data-name": "Path 50133",
    d: "M19,42h1.662v1.662H19Z",
    transform: "translate(-19 -42)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50134",
    "data-name": "Path 50134",
    d: "M19,42h1.662v.831H19Z",
    transform: "translate(-19 -42)",
    fill: "#ff8f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28945",
    "data-name": "Group 28945",
    transform: "translate(2.493 6.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50135",
    "data-name": "Path 50135",
    d: "M10.962,18.662c-1.3,0-1.276.831-2.962.831,0,0,1.171-2.078,2.856-2.078A17.618,17.618,0,0,0,14.649,17s-.416,1.662-1.662,1.662Z",
    transform: "translate(-7.169 -16.584)",
    fill: "#311b92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50136",
    "data-name": "Path 50136",
    d: "M13.48,16.416s-.831.831-3.324.831a2.493,2.493,0,0,0-1.6.507c-.5.324-1.09,1.155-1.722,1.155-.369,0-.831-.727-.831-1.238a2.032,2.032,0,0,0,1.143-.58A3.746,3.746,0,0,1,9.74,16,17.146,17.146,0,0,1,13.48,16.416Z",
    transform: "translate(-6 -16)",
    fill: "#7e57c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28946",
    "data-name": "Group 28946",
    transform: "translate(10.805 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50137",
    "data-name": "Path 50137",
    d: "M35.143.016a3.185,3.185,0,0,0-1.251.76.993.993,0,0,0-.1.091,4.234,4.234,0,0,0-.511.586.346.346,0,0,0-.033.05,3.612,3.612,0,0,0-.4.719,3.527,3.527,0,0,0-.15.432,2.771,2.771,0,0,0-.079.378.841.841,0,0,0-.029.183c-.012.116-.021.2-.033.266-.033.3-.021.208-.1.9l-.025.22a2.9,2.9,0,0,1-.05.307c-.017.087-.037.187-.066.291a4.523,4.523,0,0,1-.179.515,4.612,4.612,0,0,1-.482.885,4.328,4.328,0,0,1-.312.416,4.935,4.935,0,0,1-.382.411c-.108.108-.224.216-.349.32a7.757,7.757,0,0,1-1.334.906,1.954,1.954,0,0,1-1.446-.162,2.712,2.712,0,0,1-1.828-2.128.812.812,0,0,1,.058-.4,1.824,1.824,0,0,1,.561-.661c.129-.1.241-.179.362-.258a.735.735,0,0,1,.091-.066.231.231,0,0,1,.033-.025c.066-.046.3-.191.6-.374h0c.378-.233.864-.515,1.226-.74a.031.031,0,0,1,.017-.008c.262-.154.457-.278.507-.316.033-.029.062-.05.1-.075s.058-.05.083-.075a3.461,3.461,0,0,0,.482-.544V2.808a3.65,3.65,0,0,0,.307-.544l.087-.187a4.069,4.069,0,0,1,.32-.565,1.737,1.737,0,0,1,.162-.2A2.265,2.265,0,0,1,31.336.98c.054-.042.112-.083.175-.129A3.594,3.594,0,0,1,32.08.514.084.084,0,0,0,32.113.5a1.956,1.956,0,0,1,.216-.087,4.354,4.354,0,0,1,.445-.158c.121-.037.241-.066.366-.1A6.89,6.89,0,0,1,34.187.016,6.668,6.668,0,0,1,35.143.016Z",
    transform: "translate(-26.001 0.001)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50138",
    "data-name": "Path 50138",
    d: "M32.729,7.241a4.934,4.934,0,0,1-.382.411c-.108.108-.224.216-.349.32A4.4,4.4,0,0,1,28.37,5.267a.735.735,0,0,1,.091-.066.23.23,0,0,1,.033-.025c.066-.046.3-.191.6-.374C29.33,5.8,30.389,7,32.729,7.241Zm1.039-2.107c-.017.087-.037.187-.066.291a4.523,4.523,0,0,1-.179.515,4.186,4.186,0,0,1-3.179-1.887c.262-.154.457-.278.507-.316.033-.029.062-.05.1-.075s.058-.05.083-.075A3.5,3.5,0,0,0,33.768,5.134Zm.32-2.256a2.771,2.771,0,0,0-.079.378.841.841,0,0,0-.029.183c-.012.116-.021.2-.033.266a4.09,4.09,0,0,1-2.04-1.4,4.069,4.069,0,0,1,.32-.565,1.736,1.736,0,0,1,.162-.2A3.221,3.221,0,0,0,34.088,2.877Zm1.093-1.787a4.234,4.234,0,0,0-.511.586.346.346,0,0,0-.033.05A3.176,3.176,0,0,1,33.714.633a4.355,4.355,0,0,1,.445-.158c.121-.037.241-.066.366-.1A2.261,2.261,0,0,0,35.181,1.091Z",
    transform: "translate(-27.386 -0.222)",
    fill: "#ff6f00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpyroHighlighted);
export default __webpack_public_path__ + "static/media/spyroHighlighted.d6408c5892b76b92062f248414eeb639.svg";
export { ForwardRef as ReactComponent };